import { callApi } from '../../libs'

const verifyAccessToken = () => {
    return new Promise(async (resolve, reject) => {
        const url = `${process.env.REACT_APP_API_COVID19}/api/users/liff/get-user-id`
        const method = 'get'
        try {
            const response = await callApi(method, url, null, null)
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })
}

export default verifyAccessToken